import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=1baf3aed&scoped=true&"
import script from "./UserInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserInfo.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=1baf3aed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baf3aed",
  null
  
)

export default component.exports